import { Center } from "gaa-vue-lib-v2/types";
import { defineStore } from "pinia";
import { ref } from "vue";
import { LocalStorage } from "gaa-vue-lib-v2/utils";

export const useNavigationStore = defineStore("navigation", () => {
  const center = ref<Center | null>(null);

  const init = () => {
    // get local storage data
    const data = LocalStorage.getLocalStorage("app-nav");
    if (data && data.center) {
      center.value = data.center as any;
    }
  };

  return { center, init };
});
